<template>
  <el-row
    class="widget-col widget-view"
    style="height: 100%"
    :style="{ width: element.options.width }"
    v-if="element && element.key"
    :class="{ active: selectWidget.key && selectWidget.key === element.key }"
    :key="element.key"
    @click.native.stop="handleSelectWidget(index)"
  >
    <draggable
      v-model="element.list"
      v-bind="{
        group: { name: 'people', put: handlePut },
        ghostClass: 'ghost',
        animation: 200,
        handle: '.drag-widget',
      }"
      :no-transition-on-drag="true"
      @change="handleMoveEnd($event, element)"
      @add="handleWidgetCommentAdd($event, element)"
      style="width: 100%"
    >
      <transition-group name="fade" tag="div" class="widget-col-list">
        <div v-for="(item, iindex) in element.list" :key="iindex + 'comment'">
          <advanced-form-item
            v-if="Object.keys(advancedComponents).indexOf(item.type) >= 0"
            :key="item.key"
            :element="item"
            :select.sync="selectWidget"
            :index="iindex"
            :data="element"
            :data-config="dataConfig"
            @select-change="handleSelectChange($event, element)"
          >
          </advanced-form-item>
          <widget-col-item
            v-else-if="item.type === 'grid'"
            :key="item.key"
            :element="item"
            :select.sync="selectWidget"
            :index="iindex"
            :data="element"
            :data-config="dataConfig"
            @select-change="handleSelectChange($event, element)"
          >
          </widget-col-item>
          <widget-form-item
            v-else
            :key="item.key"
            :element="item"
            :select.sync="selectWidget"
            :index="iindex"
            :data="element"
            :data-config="dataConfig"
            @select-change="handleSelectChange($event, element)"
          >
          </widget-form-item>
        </div>
      </transition-group>
    </draggable>
    <div
      class="widget-view-action widget-col-action"
      v-if="selectWidget.key === element.key"
    >
      <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
    </div>

    <div
      class="widget-view-drag widget-col-drag"
      v-if="selectWidget.key === element.key"
    >
      <i class="su-icon-tuodong drag-widget"></i>
    </div>
  </el-row>
</template>

<script>
import WidgetFormItem from '../WidgetFormItem'
import WidgetColItem from '../WidgetColItem'
import { advancedComponents } from '../advanced/advanced.js'
import AdvancedFormItem from '../advanced/AdvancedFormItem'
import Draggable from 'vuedraggable'
import widgetFormUtils from '../../util/widgetFormUtils'
export default {
  name: 'widget-comment',
  props: ['element', 'select', 'index', 'data', 'dataConfig'],
  components: {
    Draggable,
    WidgetFormItem,
    AdvancedFormItem,
    WidgetColItem,
  },
  data() {
    return {
      advancedComponents,
      selectWidget: this.select,
    }
  },
  methods: {
    handlePut(a, b, c) {
      if (c.className.indexOf('widget-in-comment') >= 0) {
        return true
      }
      return false
    },
    handleMoveEnd() {},
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetDelete(index) {
      if (this.data.list.length === 1) {
        this.$emit('select-change', -1)
      } else {
        if (this.data.list.length - 1 === index) {
          this.$emit('select-change', index - 1)
        } else {
          this.$emit('select-change', index)
        }
      }
      this.data.list.splice(index, 1)
    },
    handleWidgetCommentAdd($event, row) {
      const newIndex = $event.newIndex
      widgetFormUtils.handleWidgetAdd(newIndex, null, row, this, false)
      this.selectWidget = row.list[newIndex]
    },
    handleSelectChange(index, item) {
      setTimeout(() => {
        index >= 0
          ? (this.selectWidget = item.list[index])
          : (this.selectWidget = {})
      }, 350)
    },
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.widget-col-list {
  width: 100%;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 7px;
}
</style>
